// removed by extract-text-webpack-plugin
module.exports = {"muhimma":"_2kjzDqg2LsIzMBg_auMrVL","loading":"-OMgJR3w-qRtddf9yPQkr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/root/layout.scss
// module id = 1516
// module chunks = 0